import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useNavigate } from "react-router-dom";
import { Button, Form, Row, Col } from 'react-bootstrap';
import Divider from 'components/common/Divider';
import SocialAuthButtons from './SocialAuthButtons';
import { Tooltip } from 'antd';
import {
  EmailValidation,
  PasswordValidation,
  MobileValidation,
  TextValidation,
  ConfirmPasswordValidation
} from '../../util/input-validation.js';
import { registerUser, loginUser } from '../../api/authentication';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input';
import { isValidPhoneNumber } from 'react-phone-number-input'
import { useLocation } from "react-router-dom";
import { saveUserCredentials } from "../../redux/actions/user";
import { setUserSubscription, createOrderIdAction, startUserTrial } from "../../redux/actions/packageAction";
import {deleteCookieCredentials ,setCookieCredentials, setLocalStorageObject, getLocalStorageObject, removeKeyLocalStorageObject} from '../../util/helper';

import {
  getBrokerList, 
} from "../../redux/actions/brokerAction";
import { useToast } from 'components/common/custom-toast/Toast';
let localStorageObj = getLocalStorageObject("user") || 
  {
    "userID": "",
    "userType": "",
    "email": "",
    "loginSecret": "",
    "activeSubscription": false,
    "activeTradeSubscription": false,
    "gUserRegisterRequired": false,
    "subscriptionValidTill": "",
    "trialAllowed": false,
    "tradeTrailAllowed": false,
    "webSocketChannel": "",
    "tradeSubscriptionValidTill": "",
    "src": "fnotrader",
    "isLoggedIn": true,
    "brokerLoggedIn":false
}

const RegistrationForm  = ({ hasLabel, sucessMessageHandle }) => {
  
  const initial = { gtoken :"", fname: '', lname: '', email: '', mobile: '', password: '', confirmPassword: '', isAccepted: false };
  const packageReducer = useSelector((state) => state.packageReducer);
  const [readyForPayment, setReadyForPayment] = useState(false);

  const [formData, setFormData] = useState(initial);
  const [errorText, setErrorText] = useState(initial);
  const [showErrorText, setShowErrorText] = useState(false);
  const [requestError, setRequestError] = useState();
  const [socialLogin, setSocialLogin] = useState(false);
  const [promoCode, setPromocode] = useState("");
  const [selectedPlan, setselectedPlan] = useState({});
  const [referralCode, setreferralCode] = useState("");
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useToast()

  const UserGoogleData = location.state;
  useEffect(() => {
  
    const queryParams = new URLSearchParams(location.search);
    const referralCode = queryParams.get('rc');
    if(referralCode) {
      setreferralCode(referralCode);
    }
  },[])
  useEffect(() => {
    
    let fnameStatus = TextValidation(formData.fname);
    let lnameStatus = TextValidation(formData.lname);
    let mobileStatus = formData.mobile ? isValidPhoneNumber(formData.mobile ? formData.mobile : null) : false;
    let emailStatus = EmailValidation(formData.email);
    let passwordStatus = PasswordValidation(formData.password);
    let confirmPasswordStatus = ConfirmPasswordValidation(formData.password, formData.confirmPassword);
    
    let error = {
      fname: fnameStatus ? '' : 'First Name is required',
      lname: lnameStatus ? '' : 'Last Name is required',
      mobile: mobileStatus ? '' : 'Enter a valid number',
      email: emailStatus ? '' : 'Enter a valid Email address',
      password: passwordStatus ? '' : 'Enter a valid Password',
      confirmPassword: confirmPasswordStatus ? '' : 'Password does not match',
      isAccepted: formData.isAccepted ? '' : 'You have not accept the terms and privacy policy'
    };

    setErrorText(error);
    setShowErrorText(false);
    setRequestError('');
  }, [formData]);

  useEffect(() => {
     
    if(UserGoogleData) {
      setFormData({
        ...formData,
        ['email']: UserGoogleData.email,
        ['fname']: UserGoogleData.userFirstName,
        ['lname']: UserGoogleData.userLastName,
        ['gtoken']: UserGoogleData.gToken,
      });
      setSocialLogin(true)
    }
   
     
  }, [UserGoogleData]);
  
  // useEffect(() => {
  //   if (packageReducer.suscriptionOrderId) {
  //     if (readyForPayment) {
  //       setReadyForPayment(false);
  //       history.push("/payment",{selectedPlan:selectedPlan,promoCode:promoCode});
  //     }
  //   }
  // }, [packageReducer.suscriptionOrderId]);

  // Handler
  // const handleSubmit = e => {
  //   e.preventDefault();
  //   toast.success(`Successfully registered as ${formData.name}`);
  // };

 

  const handleFieldChange = e => {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value
      });

  
  };

  const startFreeTrial = () => {
   
    startUserTrial().then(
      response => { 
          if(response) {
            toast.success("Your Free Trial has been Activated");
          }
          removeKeyLocalStorageObject("selectedPlan");
          navigate("/home");
      },
      error => {
         
      }
    ); 
  } 

  const createOrderId = (item) => {
 
    
    var plan = getLocalStorageObject('selectedPlan')?.plan;
    
    // let parma = {
    //   packageId: item.id,
    //   promoCode: item.promoCode,
    // };

    // if(item.active == 0) {
    //   parma.productType = "qt";
    // }
    // setselectedPlan(item)
    // setReadyForPayment(true);

    // dispatch(createOrderIdAction(parma));
    if(plan.planName=="Trial") {
      //startFreeTrial();
      navigate("/pricing");
    } else if(plan.planName == "Free"){
      // toast.success("QuikTrade is enabled for Zerodha only. Other brokers are enabled soon");
      // removeKeyLocalStorageObject("selectedPlan");
      // navigate("/trading/broker-accounts");
      navigate("/pricing");
    }else {
      navigate("/pricing");
    }

    
  };
  
  const clearData = () => {
    setFormData(initial);
  };

  const handleFormSubmit = async (event) => {
      event.preventDefault();
      
      if(!socialLogin) {
        if(errorText.password || errorText.confirmPassword) {
          setShowErrorText(true);
          return;
         }
      }
      

      if (
          (!errorText.fname &&
          
          !errorText.mobile &&
          !errorText.email &&
          !errorText.isAccepted)
          
         

      ) {
         

         
          formData.rc = referralCode; 
          const data = await registerUser(formData);

          if (data?.code === 200) {

               if(socialLogin) {
                handleSubmit();
               } else {
                 // setShowSucessMessage(true);
                const email = formData.email;
                sucessMessageHandle(true, email);
                clearData();
               }
             
              // toast.success(`Successfully registered with  ${formData.name}`);
              
          } else if (data?.error) {

              setRequestError(data?.error);
          } else {
              setRequestError("Please check your internet connection and try again");
          }
      } else {
          setShowErrorText(true);
      }
  };

   // Handler
   const handleSubmit = async () => {
    
    // toast.success(`Logged in as ${formData.email}`);
        const loginData = {
          email: "",
          password: "",
          gtoken: UserGoogleData.gToken
      };
      const data = await loginUser(loginData);

      if (data?.code === 200) {
        const {loginSecret, email, userID, webSocketChannel,subscriptionValidTill,activeSubscription,activeTradeSubscription,brokerLoggedIn} = data?.data;
       
        setCookieCredentials({...data?.data, isLoggedIn: true}, localStorageObj);
        dispatch(saveUserCredentials({...data?.data, isLoggedIn: true,brokerLoggedIn:false}));

        setTimeout(async () => {
          const brokerData =  await  dispatch(getBrokerList('loggedIn'));
          const hasQuickTrade = brokerData?.brokers?.some(b => b.quickTrade && b.status === "loggedIn");
          if(hasQuickTrade) {
            dispatch(saveUserCredentials({...data?.data, isLoggedIn: true,brokerLoggedIn:true}));
            //document.cookie= "brokerLoggedIn=" + true;
            setLocalStorageObject('user', 'brokerLoggedIn', true, localStorageObj);
            
          } else {
            dispatch(saveUserCredentials({...data?.data, isLoggedIn: true,brokerLoggedIn:false}));
            //document.cookie= "brokerLoggedIn=" + false;
            setLocalStorageObject('user', 'brokerLoggedIn', false, localStorageObj);
            
          }
        }, 1000)

        if(activeTradeSubscription) {
        dispatch(setUserSubscription(data.subscriptionValidTill));
          clearData();
          navigate("/home");
        } else {
          navigate("/pricing")
        }
        
      } else if (data?.error) {
        setRequestError(data?.error);
      } else {
        setRequestError("Please check your internet connection and try again");
      }
    
  };


  return (
    <Form onSubmit={handleFormSubmit}>
      <Row className="g-2 mb-3">
          <Form.Group as={Col} sm={6}>
          {hasLabel && <Form.Label style={{marginBottom: "0.5rem"}}>First Name</Form.Label>}
          <Form.Control
            required
            placeholder={!hasLabel ? 'First Name' : ''}
            value={formData.fname}
            name="fname"
            onChange={handleFieldChange}
            type="text"
            readOnly={socialLogin}
            style={{fontSize: "1rem"}}

          />
          {showErrorText && (
            <p className="text-danger" style={{fontSize : '12px'}}>{errorText.fname}</p>
          )}
        </Form.Group>
        <Form.Group as={Col} sm={6}>
          {hasLabel && <Form.Label style={{marginBottom: "0.5rem"}}>Last Name</Form.Label>}
          <Form.Control
             
            placeholder={!hasLabel ? 'Last Name' : ''}
            value={formData.lname}
            name="lname"
            onChange={handleFieldChange}
            type="text"
            readOnly={socialLogin}
            style={{fontSize: "1rem"}}

          />
          {/* {showErrorText && (
            <p className="text-danger" style={{fontSize : '12px'}}>{errorText.lname}</p>
          )} */}
        </Form.Group>
      </Row>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label style={{marginBottom: "0.5rem"}}>Email address  <Tooltip title="Verification email will be sent to this address & validate - proper format">
          <span className="tooltip-icon">?</span>
        </Tooltip></Form.Label>}
        <Form.Control
          required
          placeholder={!hasLabel ? 'Email address' : ''}
          value={formData.email}
          name="email"
          onChange={handleFieldChange}
          type="text"
          readOnly={socialLogin}
          style={{fontSize: "1rem"}}
        />
       
        {showErrorText && (
          <p className="text-danger" style={{fontSize : '12px'}}>{errorText.email}</p>
        )}
      </Form.Group>

      <Form.Group className="mb-3">
            {hasLabel && <Form.Label style={{marginBottom: "0.5rem"}}>WhatsApp Number
          
         </Form.Label>}
        {/* <Form.Control
          required
          placeholder={!hasLabel ? 'Mobile' : '1234512345'}
          value={formData.mobile}
          name="mobile"
          onChange={handleFieldChange}
          type="text"
        /> */}
          <PhoneInput
          international
          countryCallingCodeEditable={false}        
          defaultCountry="IN"
          placeholder="Enter whatsApp Number"
         // style={{border:"1px solid #d8e2ef"}}
          //value={value}
          className="phone-react-n"
          onChange={e =>
            setFormData({
              ...formData,
              'mobile': e
            })
          }/>
        {showErrorText && (
          <p className="text-danger" style={{fontSize : '12px'}}>{errorText.mobile}</p>
        )}
      </Form.Group>
    {!socialLogin && 
      <Row className="g-2 mb-3">
        <Form.Group as={Col} sm={6}>
          {hasLabel && <Form.Label style={{marginBottom: "0.5rem"}}>Password</Form.Label>}
          <Form.Control
            required
            placeholder={!hasLabel ? 'Password' : ''}
            value={formData.password}
            name="password"
            onChange={handleFieldChange}
            type="password"
            min="8"
            style={{fontSize: "1rem"}}

          />
         {showErrorText && (
            <p className="text-danger" style={{fontSize : '12px'}}>{errorText.password}</p>
          )}
        </Form.Group>
        <Form.Group as={Col} sm={6}>
          {hasLabel && <Form.Label style={{marginBottom: "0.5rem"}}>Confirm Password</Form.Label>}
          <Form.Control
            required
            placeholder={!hasLabel ? 'Confirm Password' : ''}
            value={formData.confirmPassword}
            name="confirmPassword"
            onChange={handleFieldChange}
            type="password"
             min="8"
             style={{fontSize: "1rem"}}

          />
          {showErrorText && (
            <p className="text-danger" style={{fontSize : '12px'}}>{errorText.confirmPassword}</p>
          )}
        </Form.Group>

        {referralCode &&
          <Form.Group as={Col} sm={6}>
            <Form.Label style={{marginBottom: "0.5rem"}}>Referral Code</Form.Label>
            <Form.Control
              
              placeholder={'Referral Code'}
              value={referralCode}
              name="referralCode"
              type="text"
              readOnly
              style={{fontSize: "1rem"}}
            />
          
          </Form.Group>
       }
      </Row>
     }

      <Form.Group className="mb-3">
        <Form.Check type="checkbox" id="acceptCheckbox" className="form-check">
          <Form.Check.Input
            type="checkbox"
            name="isAccepted"
            checked={formData.isAccepted}
            onChange={e =>
              setFormData({
                ...formData,
                isAccepted: e.target.checked
              })
            }
          />
          <Form.Check.Label className="form-label">
            I accept the <Link to="/terms-condition">terms</Link> and{' '}
            <Link to="/privacy-policy">privacy policy</Link>
          </Form.Check.Label>
        </Form.Check>
      </Form.Group>

      <Form.Group className="mb-4">
        {requestError && (
            <p style={{ color: 'red' }}>
                * <span style={{textTransform:"capitalize" }}>{requestError.charAt(0)}</span>{requestError.substring(1)}{' '}
            </p>
        )}
        <Button
          className="w-100"
          type="submit"
          disabled={
            !formData.fname ||
            
            !formData.email ||
            !formData.mobile ||
            !formData.isAccepted 
          
          }
        >
          Register
        </Button>
      </Form.Group>
    </Form>
  );
};

export default RegistrationForm;
